<template>
  <div>
    <div class="border_btm py-2">
      <h4 class="mb-4">Course Enrollment</h4>
      <div class="flex flex-wrap items-center py-4">
        <span class="pr-3">Enrollment Approval Requirements</span>
        <vs-switch
          v-model="courseEnrollmentSetting.enrollment_approval_requirements"
        />
      </div>
      <div class="py-4">
        <vs-radio
          v-model="courseEnrollmentSetting.enrollment_approval_type"
          name="enroll_opt"
          vs-value="1"
          class="pr-4"
        >
          Manual Review
        </vs-radio>
        <vs-radio
          v-model="courseEnrollmentSetting.enrollment_approval_type"
          name="enroll_opt"
          vs-value="2"
        >
          Auto check Prerequisites
        </vs-radio>
      </div>

      <editor
        ref="tinyMce"
        v-model="courseEnrollmentSetting.prerequisite"
        :api-key="tinyMceApi"
        :init="initializeTinyMce"
      />
    </div>
            <div class="flex flex-wrap justify-between items-center mt-4">
       <vs-button type="border" @click="prevPage" v-if="!$route.params.course_id"
      >Back</vs-button
    >
    <vs-button @click="enrollCourse()" 
      >Save & Next</vs-button
    >
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import {
  updateCourseEnrollmentSetting,
  getCourseEnrollmentSetting
} from '@/api/courseBuilder.js'

export default {
  props: {
    courseId: {
      required: true,
      default: null
    },
    counter: {
      required: true,
      default: 0
    }
  },
  data () {
    return {
      course_id: '',
      courseEnrollmentSetting: {
        enrollment_approval_requirements: false,
        enrollment_approval_type: '',
        prerequisite: ''
      },
      customer_id: localStorage.getItem('customer_id'),
      enrollment: true,
      enroll_opt: 'Manual Review',
      tinyMceApi: '',
      initializeTinyMce: {
        setup: editor => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction: () => {
              this.importModelRepo(editor)
            }

            /* onAction: () => {
              
              editor.insertContent('&nbsp;<strong>It\'s my button!</strong>&nbsp;')
            } */
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }

            /* onAction: () => {
              
              editor.insertContent('&nbsp;<strong>It\'s my button!</strong>&nbsp;')
            } */
          })
        },
        height: 400,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.images_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \        table alignleft aligncenter alignright alignjustify | \        bullist numlist outdent indent | removeformat | help'
      }
    }
  },
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    if (this.course_id) {
      this.getEnrollmentDetails()
    }
  },
  components: {
    editor: Editor
  },
  watch: {
    counter () {
      // if (this.counter === 3) {
      this.course_id = this.courseId
      this.getEnrollmentDetails()
      //}
    }
  },
  methods: {
    async prevPage () {
      this.$emit('prevPage', 2)
    },
    async enrollCourse () {
      try {
        const payload = {
          courseEnrollmentSetting: this.courseEnrollmentSetting
        }
        const data = await updateCourseEnrollmentSetting(
          this.customer_id,
          this.course_id,
          payload
        )
        this.$emit('nextTab', 4)
      } catch (e) {}
    },
    async getEnrollmentDetails () {
      try {
        const { data } = await getCourseEnrollmentSetting(
          this.customer_id,
          this.course_id
        )
        this.courseEnrollmentSetting = data.data.courseEnrollmentSetting
        console.log(this.courseEnrollmentSetting)
      } catch (e) {}
    }
  }
}
</script>
